export { default } from './ContentWidget';
